<template>
  <form
    action="/cart/add"
    method="post"
    enctype="multipart/form-data"
    novalidate
    ref="productForm"
    @submit.prevent="addToCart"
  >
    <slot></slot>
  </form>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "product-form",
  props: {
    selectId: { type: String, default: "id" },
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
    }),
    ...mapGetters({
      getProperties: "metafields/getProperties",
    }),
  },
  methods: {
    async addToCart() {
      const form = this.$refs.productForm;
      const { product } = JSON.parse(
        document.querySelector(".js-product-json").innerHTML
      );

      // send optimize activation event for cart containing an always pan
      const mainProductsReg = new RegExp("always-essential-cooking-pan");
      if (mainProductsReg.test(product.handle)) {
        window.dataLayer?.push?.({ event: "cart-contents.always-pan" });
      }

      const formData = new FormData(form);
      const quantity = formData.get("quantity");
      const variantId = formData.get(this.selectId);
      const upsellActive = formData.get("pdp-upsell-active");

      const items = [];
      items.push({
        id: parseInt(variantId),
        quantity: parseInt(quantity),
        properties: this.getProperties(variantId),
      });

      if (upsellActive) {
        const upsellVariantId = formData.get("pdp-upsell");
        items.push({
          id: parseInt(upsellVariantId),
          quantity: parseInt(quantity),
          properties: this.getProperties(upsellVariantId),
        });
      }

      await this.$store.dispatch("cart/addToCart", items);
      await this.$store.dispatch("cart/toggleCart");
    },
  },
};
</script>
